import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addProcessRemark = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/addprocessremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchAddProcessRemark = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/batchaddprocessremark/' + params.ids + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const analyzeSingle = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/analyzesingle/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisresult/getteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}
